var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/57433da99c013a02deec84c0e50a25bd.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8644dfba4b069501cfa2572fc0352b99.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    